import Environment from "services/environment/index";
const env = Environment.getEnv();

export const requirePartyId = (lob) => window.isInternalUser || env.PARTY_SUPPORTED_LOB.includes(lob);

export const appendPartyId = (url, lob, partyId) => {
  if (requirePartyId(lob)) {
    url = new URL(url);
    url.searchParams.append("partyId", partyId);
    url = url.toString();
  }
  return url;
};
